import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Row, Col, Button } from "antd";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import TimeInput from "../TimeInput";
import DateInput from "../DateInput";

const { Option } = Select;

const RideTypeInput = (props: any) => {
  const { value, placeholder, onChange, dispatchOptions } = props;
  const [options, setOptions] = useState(dispatchOptions || [
    { id: "oneWay", name: "One way" },
    { id: "roundTrip", name: "Round trip" },
  ]);

  return (
    <React.Fragment>
      {/* <Select
        showSearch
        value={value?.value}
        className="w-full"
        placeholder={placeholder}
        onChange={(value) => {
          onChange({
            value,
            type: "rideType",
          });
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options?.map((option, index) => (
          <Option key={index} value={option.id}>
            {option.name}
          </Option>
        ))}
      </Select> */}

<div className="tiles padding-12">
          {/* <span className="col-label">{data?.label}</span> */}
      <Row className="">
      <Col span={6} className="d-flex align-items-center">
        {/* <h5 className="mb-0">Dispatch type</h5> */}
        <span className="col-label">Ride type</span>
        </Col>
        {options?.map((option, index) => (
          <Col span={6}>
            <Button
              onClick={() => {
                onChange({
                  value: option.id,
                  type: "rideType",
                });
              }}
              className={`beam-btn ${
                value?.value === option.id ? "green-btn cover" : ""
              }`}
            >
              {option.name}
            </Button>
          </Col>
        ))}
      </Row>

      {value && value?.value !== "oneWay" && (
        <Row className="mt-3">
          <Col span={12} className="pr-2">
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <DateInput
                placeholder={"Select date"}
                valuce={value?.date}
                onChange={(date) => {
                  onChange({
                    value: value?.value,
                    type: "rideType",
                    date,
                    time: value?.time,
                  });
                }}
              />
            </div>
          </Col>
          <Col span={12}>
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <TimeInput
                name={"Select time"}
                valuce={value?.time}
                onChange={(time) => {
                  onChange({
                    value: value?.value,
                    type: "rideType",
                    date: value?.date,
                    time,
                  });
                }}
              />
            </div>
          </Col>
        </Row>
      )}

      </div>
    </React.Fragment>
  );
};

export default RideTypeInput;
